/**
 * Whose shared space this is, as the guest flow names it: the owner's first
 * name, then the workspace's name. Never the email, the same rule
 * `chatOwnerName` follows. Null when there is neither; the caller supplies its
 * own "a shared space".
 *
 * Takes a workspace listing row (`owner_first_name`, `name`) or an invitation
 * preview (`owner_first_name`, `workspace_name`), so the accept page and the
 * guest flow say the same thing.
 */
export function hostName(workspace) {
  if (!workspace) return null;
  return workspace.owner_first_name || workspace.name || workspace.workspace_name || null;
}
